import { Box, BoxProps, Text } from "@vinomofo/components";

import { CurrencyLabel } from "../currency";
import { useCart } from "../../hooks/use-cart";
import { useCredits } from "../../hooks/account/use-credits";

export const CartStoreCredit = (props: BoxProps): JSX.Element => {
  const { credits, isLoading } = useCredits();
  const { cart, isLoading: isLoadingCart } = useCart();

  return (
    (!isLoading || !isLoadingCart) &&
    credits > 0 && (
      <Box
        display="flex"
        width="100%"
        justifyContent="space-between"
        alignItems="center"
        padding={3}
        borderTop="1px solid"
        borderTopColor="divider"
        {...props}
      >
        <Text fontSize={1} color="heading">
          Store credit
          {credits > cart?.cartTotal && (
            <>
              <br />
              <Text fontSize="12px">
                {`Remaining : $${(credits - cart?.cartTotal).toFixed(2)}`}
              </Text>
            </>
          )}
        </Text>
        <Text fontSize={1} color="text.default" fontWeight={500}>
          <CurrencyLabel
            amount={credits >= cart?.cartTotal ? -cart?.cartTotal : -credits}
            showFree
          />
        </Text>
      </Box>
    )
  );
};
